import { useInfiniteQuery } from "@tanstack/react-query";

import { getActionsByAccount } from "@/api/graphql/actions/agent/api.ts";
import { reducePages } from "@/api/graphql/actions/agent/mappers.ts";
import { useGetActionsByAccountProps } from "@/api/graphql/actions/agent/types.ts";
import { queries } from "@/api/graphql/constants.ts";
import { AccountsMsSearchAuditLogsRequestSortField } from "@/api/graphql/types/graphql.ts";
import { getNextPageParam } from "@/helpers/api/getNextPageParam";

export const useGetActionsByAccount = ({
  pageSize,
  accountId,
}: useGetActionsByAccountProps) => {
  const response = useInfiniteQuery({
    queryKey: [queries.GET_ACTIONS_BY_ACCOUNT, accountId],
    queryFn: async ({ pageParam = 1 }) =>
      await getActionsByAccount({
        filters: { accountIds: [accountId] },
        paging: {
          page: pageParam,
          size: pageSize,
        },
        sorts: {
          field: AccountsMsSearchAuditLogsRequestSortField.WhenTs,
          ascending: false,
        },
      }),
    getNextPageParam: (lastPage, allPages) =>
      getNextPageParam({
        lastPage,
        allPages,
        key: "AccountsMsSearchAuditLogs",
      }),
    initialPageParam: 1,
  });
  const actions = response.data ? reducePages(response.data) : [];

  return {
    isActionsLoading: response.isLoading,
    hasNextPage: response.hasNextPage,
    fetchNextPage: response.fetchNextPage,
    actions,
    totalActions:
      response.data?.pages[0]?.AccountsMsSearchAuditLogs.pagination.total || 0,
  };
};
